import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionActions from "@mui/material/AccordionActions";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import moment from "moment";

const DATE_FORMAT = "DD MMM YYYY HH:mm:ss";

const MESSAGE_TYPES = {
  share_template: "A dashboard template was shared with you by",
};

const getMessageDetails = (msg) => {
  let info;
  if (msg.message_type === "share_template") {
    const template = msg.message_payload && msg.message_payload.template;
    if (template) {
      try {
        info = (
          <Typography>{`Dashboard Title: ${
            JSON.parse(template).title
          }`}</Typography>
        );
      } catch (e) {
        // do nothing
      }
    }
  }
  return info || <div></div>;
};

const MessagesDialog = (props) => {
  async function accept(msg) {
    if (msg.message_type === "share_template") {
      const template = msg.message_payload && msg.message_payload.template;
      if (template) {
        const parsedTemplate = JSON.parse(template);
        const sender = msg.sender.name || msg.sender.email;
        const guuid = await props.copyDashboardTemplate(parsedTemplate, sender);
        window.location.hash = "#/dashboard/" + guuid;
        props.removeMessage(msg.guuid);
        props.handleClose();
      }
    }
  }

  const remove = (msg) => {
    props.removeMessage(msg.guuid);
  };

  const messages = Object.values(props.messages);
  return (
    <Dialog maxWidth={false} open={props.open} onClose={props.handleClose}>
      <DialogTitle>Your Pending Messages</DialogTitle>
      <DialogContent style={{ marginBottom: "1em" }}>
        {messages.length > 0 ? (
          messages.map((msg) => {
            const senderInfo = msg.sender.name
              ? `${msg.sender.name} (${msg.sender.email})`
              : msg.sender.email;
            return (
              <Accordion key={msg.guuid}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography color="primary" style={{ marginRight: "2em" }}>
                      {msg.tm_generated
                        ? moment(parseInt(msg.tm_generated)).format(DATE_FORMAT)
                        : "---"}
                    </Typography>
                    <Typography>
                      {`${
                        MESSAGE_TYPES[msg.message_type] ||
                        "Unknown message type from"
                      } ${senderInfo}`}
                    </Typography>
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  {getMessageDetails(msg)}
                </AccordionDetails>
                <AccordionActions>
                  <Button size="small" onClick={() => remove(msg)}>
                    Remove
                  </Button>
                  <Button
                    size="small"
                    color="primary"
                    onClick={() => accept(msg)}
                  >
                    Accept
                  </Button>
                </AccordionActions>
              </Accordion>
            );
          })
        ) : (
          <DialogContentText>
            You have no more outstanding messages.
          </DialogContentText>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default MessagesDialog;
